// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// const services = [
//   {
//     id: 1,
//     icon: "/images/icon-service-1.svg",
//     title: "Corporate Cab Services",
//     description:
//       "Reliable and efficient corporate cab services tailored to meet all your business travel requirements.",
//     delay: "0s"
//   },
//   {
//     id: 2,
//     icon: "/images/icon-service-2.svg",
//     title: "Employee Transportation",
//     description:
//       "Safe and efficient daily staff pick-up and drop services to ensure smooth commutes for your employees.",
//     delay: "0.25s"
//   },
//   {
//     id: 3,
//     icon: "/images/icon-service-3.svg",
//     title: "Airport Transfers",
//     description:
//       "Timely and comfortable airport transfer solutions for executives, clients, and employees — 24/7 availability.",
//     delay: "0.5s"
//   },
//   {
//     id: 4,
//     icon: "/images/icon-service-4.svg",
//     title: "Outstation & Intercity Travel",
//     description:
//       "Seamless and comfortable travel between cities for meetings, events, and business tours across India.",
//     delay: "0.75s"
//   }
// ];

// const OurServices = () => {
//   return (
//     <section className="our-services bg-section">
//       <div className="container">
//         {/* Section Title */}
//         <div className="row section-row">
//           <div className="col-lg-12">
//             <div className="section-title text-center">
//               <h3 className="wow fadeInUp">our services</h3>
//               <h2 className="text-anime-style-3" data-cursor="-opaque">
//                 Premium Corporate Travel Solutions by Aaryan Travels
//               </h2>
//               <p className="wow fadeInUp" data-wow-delay="0.25s">
//                 Aaryan Travels offers a complete range of corporate cab and travel
//                 services designed for comfort, safety, and reliability. Whether it’s
//                 daily commutes, airport transfers, or outstation business trips — we’ve
//                 got you covered across India.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Service Items */}
//         <div className="row">
//           {services.map((service) => (
//             <div key={service.id} className="col-lg-3 col-md-6">
//               <div
//                 className="service-item wow fadeInUp"
//                 data-wow-delay={service.delay}
//               >
//                 <div className="icon-box">
//                   <img src={service.icon} alt={service.title} />
//                 </div>
//                 <div className="service-content">
//                   <h3>{service.title}</h3>
//                   <p>{service.description}</p>
//                 </div>
//                 <div className="service-footer">
//                   <a href="/contact-us" className="section-icon-btn">
//                     <img src="/images/arrow-white.svg" alt="arrow" />
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

     
        
//       </div>
//     </section>
//   );
// };

// export default OurServices;








import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const services = [
  {
    id: 1,
    image: "/images/Ourfleet/corporate-cab-service.jpg",
    title: "Corporate Cab Services",
    description:
      "Reliable and efficient corporate cab solutions for daily business travel, meetings, and executive movement.",
    delay: "0s",
  },
  {
    id: 2,
    image: "/images/Ourfleet/employee-transportation.jpg",
    title: "Employee Transportation",
    description:
      "Safe and timely employee pick-up and drop-off with trained drivers and well-maintained vehicles.",
    delay: "0.25s",
  },
  {
    id: 3,
    image: "/images/Ourfleet/airport-tranport.jpg",
    title: "Airport Transfers",
    description:
      "24/7 airport pickup and drop services for executives, clients, corporate guests, and VIP travelers — ensuring a seamless travel experience.",
    delay: "0.5s",
  },
  {
    id: 4,
    image: "/images/Ourfleet/outstation.jpg",
    title: "Outstation / Intercity Travel",
    description:
      "Comfortable and hassle-free outstation travel for corporate trips, events, and official tours ensuring a smooth journey.",
    delay: "0.75s",
  },
];

const OurServices = () => {
  return (
    <section className="our-services section_70">
      <div className="container">

        {/* Section Heading */}
        <div className="row">
          <div className="col-md-12 text-center">
             <div className="section-title text-center">
                <h3 className="wow fadeInUp">Our Services</h3>
              
            {/* <h4 className="wow fadeInUp">Our Services</h4> */}
            <h2 className="wow fadeInUp" data-wow-delay="0.25s">
              Premium Corporate Travel Solutions
            </h2>
          </div>
        </div>
 </div>
        {/* Service Boxes */}
        <div className="row">
          {services.map((service) => (
            <div key={service.id} className="col-md-3 col-sm-6">
              <div
                className="service-box wow fadeInUp"
                data-wow-delay={service.delay}
              >
                <div className="service-img">
                  <img src={service.image} alt={service.title} />
                </div>

                <div className="service-info">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>

                <a href="/services" className="service-btn">
                  <i className="fa fa-arrow-right"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurServices;
